module.exports = __webpack_public_path__ + "img/logo-obrigado.6c3d089a.png";